export enum IdpNotificationType {
  CREATE_EXTERNAL_IDP_SUCCESS = 'CREATE_EXTERNAL_IDP_SUCCESS',
  CREATE_EXTERNAL_IDP_ERROR = 'CREATE_EXTERNAL_IDP_ERROR',
  VERIFY_EXTERNAL_IDP_ERROR = 'VERIFY_EXTERNAL_IDP_ERROR',
  DELETE_EXTERNAL_IDP_SUCCESS = 'DELETE_EXTERNAL_IDP_SUCCESS',
  DELETE_EXTERNAL_IDP_ERROR = 'DELETE_EXTERNAL_IDP_ERROR',
}
